import {Modify, Select, Translate,} from "ol/interaction";
import {getBookmarkPresentationsByID, getLayerByName, refreshAllActiveLayers} from "@/helpers/ol/ol-layer-helper";
import {Fill, RegularShape, Stroke, Style, Text} from "ol/style";
import CircleStyle from "ol/style/Circle";
import {getFeatureByFeatureID} from "@/helpers/ol/ol-feature-helper";
import Transform from "ol-ext/interaction/Transform.js";
import {always, shiftKeyOnly} from "ol/events/condition.js";
import {convertColor} from "@/helpers/color-helper.js";
import {hideElementsBySelector} from "@/helpers/element-helper.js";

let select
let translate
let activeFeature
let activeFeatureClone
let moveLayerBookmarkPresentationID

export function isMoveLayerActive() {
    if(select !== undefined) {
        return true
    }
    return false
}

export function getMoveLayerBookmarkPresentationID() {
    return moveLayerBookmarkPresentationID
}

export function moveLayer(bookmarkPresentationID, featureID, type = 'move', withPrefix = true) {

    const vectorLayer = getLayerByName(bookmarkPresentationID, withPrefix)
    if(!vectorLayer) {
        return false
    }

    const bookmarkPresentation = getBookmarkPresentationsByID(bookmarkPresentationID)

    disableMoveLayer()

    if(featureID) {
        activeFeature = getFeatureByFeatureID(bookmarkPresentationID, featureID, bookmarkPresentation.PrimaryKeyName)
    }

    moveLayerBookmarkPresentationID = bookmarkPresentationID

    select = new Select({
        // condition: pointerMove,
        style: new Style({
            fill: new Fill({
                color: 'rgba(255, 217, 80, 0.5)',
            }),
            stroke: new Stroke({
                color: '#ffd950',
                width: 2,
            }),
            image: new CircleStyle({
                radius: 7,
                fill: new Fill({
                    color: '#ffd950',
                }),
            }),
        }),
        layers: [vectorLayer],
        filter: function(feature) {
            if(featureID) {
                return feature.id_ === featureID;
            }
            return true
        }
    });

    if(type === 'move') {

        if(activeFeature && activeFeature.getGeometry().getType() === 'Point') {
            translate = new Translate({
                features: select.getFeatures(),
            });
            map.addInteraction(translate);
        } else {
            translate = new Transform ({
                enableRotatedTransform: true,
                /* Limit interaction inside bbox * /
                condition: function(e, features) {
                  return ol.extent.containsXY([-465960, 5536486, 1001630, 6514880], e.coordinate[0], e.coordinate[1]);
                },
                /* */
                features: select.getFeatures(),
                addCondition: shiftKeyOnly,
                // filter: function(f,l) { return f.getGeometry().getType()==='Polygon'; },
                // layers: [vector],
                hitTolerance: 2,
                translateFeature: true,
                scale: false,
                rotate: true,
                keepAspectRatio: always,
                keepRectangle: false,
                translate: true,
                stretch: false,
                // Get scale on points
                pointRadius: function(f) {
                    var radius = f.get('radius') || 10;
                    return [radius, radius];
                }
            });

            map.addInteraction(translate);

            const style = window.settings.wfsStyle
            //
            // let strokeColor = 'rgba(' + convertColor(style.strokeColor).rgbToString + ', ' + style.strokeOpacity + ')'
            // let fillColor = 'rgba(' + convertColor(style.fillColor).rgbToString + ', ' + style.fillOpacity + ')'
            // let strokeWidth = style.strokeWidth
            // let radius = style.pointRadius

            const strokeColor = convertColor(style.strokeColor).rgb

            translate.setDefaultStyle({
                stroke:
                    new Stroke(
                    {
                        color: [strokeColor.r, strokeColor.g, strokeColor.b, 1], width: 1
                    }),
                strokedash:
                    new Stroke(
                    {
                        color: [strokeColor.r, strokeColor.g, strokeColor.b, 1], width: 1, lineDash: [4, 4]
                    })
            })


            translate.set('translate', translate.get('translate'));
        }

    } else {
        translate = new Modify({
            features: select.getFeatures(),
        });
        window.map.addInteraction(translate);
    }

    window.map.addInteraction(select);

    console.log(featureID)

    if(featureID) {
        activeFeature = getFeatureByFeatureID(bookmarkPresentationID, featureID, bookmarkPresentation.PrimaryKeyName)
        if(activeFeature) {
            activeFeatureClone = activeFeature.clone()
            select.getFeatures().clear()
            select.getFeatures().push(activeFeature)

            console.log(activeFeature)
            if(type === 'move' && activeFeature && activeFeature.getGeometry().getType() !== 'Point') {
                translate.select(activeFeature, true)
            }

        }
    } else {
        select.getFeatures().clear()
        select.getFeatures().push(vectorLayer.getSource().getFeatures()[0])
    }

    // translate.on('change', function(evt){
    //     // console.log(evt)
    //     // console.log('changee')
    // })

    return true
}

export function disableMoveLayer(withRefresh = false) {

    if(select !== undefined) {
        window.map.removeInteraction(select);
        window.map.removeInteraction(translate);
        select = undefined
        moveLayerBookmarkPresentationID = undefined
        delete window.mutation_geom
    }

    if(withRefresh) {
        hideElementsBySelector('layer-info-info-mutation-standalone-edit-geometry-save')
        hideElementsBySelector('layer-info-info-mutation-standalone-edit-geometry-cancel')
        refreshAllActiveLayers()
    }
}
